import { twMerge } from "tailwind-merge";

export interface TabsItemProps {
  title: string;
  active?: boolean;
}
export interface TabsProps {
  className?: string;
  items: TabsItemProps[];
  onClick: (tab: string) => void;
}

export const Tabs = ({
  className,
  items = [],
  onClick = () => {},
}: TabsProps) => {
  return (
    <div
      className={twMerge(
        "text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700",
        className,
      )}
    >
      <ul className="flex flex-wrap -mb-px">
        {items.map(({ active, title }) => (
          <li className="me-2" key={title}>
            <button
              className={`inline-block p-4 border-b-2 text-lg rounded-t-lg 
                ${
                  active
                    ? "active border-b-2 border-brand font-semibold text-gray-950"
                    : "font-medium"
                }`}
              onClick={() => onClick(title)}
              {...(active && { "aria-current": "page" })}
              aria-current="page"
            >
              {title}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
